import { Component, OnInit } from '@angular/core';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import {
  IcecontrolPermission, IcecontrolSettings, ChartTypes, IcepanelSettings
} from 'projects/icemedx-lib/src/components/models/icesettings';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { Router } from '@angular/router';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { reportdata } from '../../../../icemedx-lib/src/models/reports/reportdata';
import { ReportService } from '../../../../icemedx-lib/src/services/report/report.service';
import { reportindex } from '../../../../icemedx-lib/src/models/reports/reportindex';
import { report } from '../../../../icemedx-lib/src/models/reports/report';
import { accountingsummary } from '../../../../icemedx-lib/src/models/stats/accountingsummary';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

export class IceaccountsummaryiconSettings {
  currentARTotal: number = 0.00;
  currentRevenue: number = 0.00;
  currentAPTotal: number = 0.00;
  currentAPPayments: number = 0.00;

  collectedTotal: number = 0.00;
  collectedAPTotal: number = 0.00;

  overdueARTotal: number = 0.00;
  overdueARRoute: string = "";
  overdueAPTotal: number = 0.00;
  overdueAPRoute: string = "";

  overdueARAverageDays: number = 0;
  overdueAPAverageDays: number = 0;
}

@Component({
  selector: 'app-summary',
  templateUrl: './accountingsummary.component.html',
  styleUrls: ['./accountingsummary.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class AccountingSummaryComponent implements OnInit {

  hideAccountingPeriod: boolean = true;

  iconSettings: IceaccountsummaryiconSettings = new IceaccountsummaryiconSettings();
  thisYear = Iceutility.getYear();
  summaryPermission: IcecontrolPermission = null;
  summaryReport: report = null;
  summaryReportData: reportdata = null;
  accountingSummaryChart: IcecontrolSettings = new IcecontrolSettings("icegooglechart", { width: "250px" }, null, null, "accountsummarychart", "Accounting Summary");

  currentScheduleReportSelected: string = "";
  currentScheduleReportPanel: IcepanelSettings = new IcepanelSettings("", "", "", "", []);
  scheduleReportCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ScheduleReport", "Schedule and Day Sheet Reports")
    .setControlName("ScheduleReport")
    .createFormControl("", []);

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private rptSvc: ReportService,
    ptSvc: PatientService,
    private acctSvc: AccountingService,
    private breadcrumbSvc: BreadcrumbService,
    private router: Router) {
    this.appSvc.defaultMenus();

    // To do setup accounting period
    let dt = Iceutility.GetLocalDate();
    let from = "01/01/" + dt.getFullYear() + " 12:00 AM";
    let to = dt.toLocaleDateString() + " 11:59 PM";

    let api = "";
    let acttype = this.appSvc.getCurrentAccountType();
    switch (acttype) {
      case IceTypes.ACCOUNT_TYPE.actFacility:
      case IceTypes.ACCOUNT_TYPE.actProvider:
        api = "providers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPharmacy:
        api = "pharmacies";
        break;
      case IceTypes.ACCOUNT_TYPE.actPayer:
        api = "payers";
        break;
      default:
        return;
    }

    let completeSummary: Function = (data) => {
      if (data != null && data.length > 0) {
        let rptDat = <reportdata>data[0];
        if (rptDat == null)
          return;

        if (rptDat.ACCOUNTING_SUMMARY == null || rptDat.ACCOUNTING_SUMMARY.length == 0)
          return;

        let rpt: report = null;
        if (data.length > 1) {
          rpt = data[1];
          if (rpt == null)
            return;
        }

        this.iconSettings.currentARTotal = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].current_ar_total);
        this.iconSettings.currentRevenue = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].current_revenue_total);
        //this.iconSettings.currentAPTotal = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].current_ap_total);
        //this.iconSettings.currentAPPayments = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].current_payments_total);

        this.iconSettings.collectedTotal = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].collected_total);
        //this.iconSettings.collectedAPTotal = Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].remittted_total);

        this.iconSettings.overdueARTotal =
          Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].overdue_30_days)
          + Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].overdue_60_days)
          + Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].overdue_90_days)
          + Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].overdue_120_days)
          + Iceutility.toDouble(rptDat.ACCOUNTING_SUMMARY[0].overdue_morethan150_days);

        this.iconSettings.overdueAPTotal = 0.00;

        this.summaryReport = rpt;
        this.summaryReportData = rptDat;

        let asumObj: accountingsummary = this.summaryReportData.ACCOUNTING_SUMMARY[0];

        let overdue = Iceutility.toDouble(asumObj.overdue_morethan150_days)
          + Iceutility.toDouble(asumObj.overdue_120_days)
          + Iceutility.toDouble(asumObj.overdue_90_days)
          + Iceutility.toDouble(asumObj.overdue_60_days)
          + Iceutility.toDouble(asumObj.overdue_30_days);
        this.iconSettings.overdueARTotal = overdue;

        this.accountingSummaryChart.setOptions([
          { name: 'Element', value: 'Totals' },
          { name: 'Total AR', value: Iceutility.toDouble(asumObj.current_ar_total), color: 'yellow' },
          { name: 'Total Revenue', value: Iceutility.toDouble(asumObj.current_revenue_total), color: 'green' },
          { name: 'Total Collected', value: Iceutility.toDouble(asumObj.collected_total), color: 'gold' },
          { name: 'Total Overdue', value: overdue, color: 'red' },
        ]);
        this.accountingSummaryChart.loadGoogleChart("accountsummarychart", ChartTypes.ctBar);
      }
    };

    let runSummary: Function = (key) => {
      acctSvc.getJournalSummary(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), from, to, "", IceTypes.coa_types.coaAR, key).subscribe(
        data => {
          completeSummary(data);
        },
        error => {
          console.log(error);
        });
    };

    rptSvc.getReports(api, this.appSvc.getCurrentAccount(), acttype, "", IceTypes.ReportType.rtAccountingSummary).subscribe(
      data => {
        if (data == null || data.length == 0) {
          runSummary("");
          return;
        }

        // To do this should be changed to only choose the accounting summary report that has the summary template
        let rpt: reportindex = <reportindex>data[0];
        runSummary(rpt.report_key);
      },
      error => {
        runSummary("");
        console.log(JSON.stringify(rptSvc.getLastErrors()));
      });

    rptSvc.getReports(api, this.appSvc.getCurrentAccount(), acttype, "", IceTypes.ReportType.rtScheduling).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }

        let opts = [];
        for (let irpt = 0; irpt < data.length; irpt++) {
          let repidx: reportindex = <reportindex>data[irpt];
          opts.push({ name: repidx.rpt_name, value: repidx.report_key });
        }

        this.scheduleReportCtrl.setOptions(opts);
      },
      error => {
        console.log(JSON.stringify(rptSvc.getLastErrors()));
      });


    this.iconSettings.overdueARRoute = this.navSvc.buildRoute("accounting/ar/overdue", false);
    this.iconSettings.overdueAPRoute = this.navSvc.buildRoute("accounting/ap/unpaid", false);

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access;
    this.summaryPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufAccountingJournals, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
    }
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
    this.breadcrumbSvc.resetBreadcrumb(BreadcrumType.btYard.toString());
    this.appSvc.addBreadcrumb("Accounting", {}, true, "", BreadcrumType.btTree, []);
  }

  getSummaryFilter(): string {
    let ret = "Accounting Summary";

    if (this.summaryReport != null
      && Iceutility.isdefined(this.summaryReport.RPTTEMPLATES)
      && this.summaryReport.RPTTEMPLATES.length > 0) {
      let thisTemplate = this.summaryReport.RPTTEMPLATES[0];
      if (thisTemplate != null
        && Iceutility.isdefined(thisTemplate.RPTFILTER)
        && thisTemplate.RPTFILTER.length > 0) {
        let thisFilter = thisTemplate.RPTFILTER[0];
        if (thisFilter != null) {
          let parts = thisFilter.value.split(",");
          let fromVal = "", toVal = "";
          if (parts.length > 0)
            fromVal = Iceutility.getDateTextEx(parts[0], null, false);
          if (parts.length > 1)
            toVal = Iceutility.getDateTextEx(parts[1], null, false);
          ret = "Accounting Summary from: " + fromVal + " - " + toVal;
          if (this.summaryReportData != null)
            ret += " Last modified on: " + (Iceutility.isTextDateTime(this.summaryReportData.modified) ? Iceutility.getDateTextEx(this.summaryReportData.modified) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.summaryReportData.modified)));
        }
      }
    }

    return ret;
  }

  getShowSummary(): boolean {
    return this.summaryPermission != null && this.summaryPermission.default_access != userTypes.USER_FEATURE_ACCESS.ufaNone && this.hideAccountingPeriod;
  }

  getScheduleReport(): string {
    let frmCtrl = this.scheduleReportCtrl.getFormControl();
    return frmCtrl.value;
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    this.appSvc.onDefaultToolbarMenuItemOpen(event);
  }
  onToolbarMenuItemClick(event) {
    this.appSvc.onDefaultToolbarMenuItemClick(event, this.router);
  }

  onPeriodActionRequired(event) {
    debugger;
    if (event.value == "NoCurrentPeriod")
      this.hideAccountingPeriod = false;
    else
      this.hideAccountingPeriod = true;
  }

  onScheduleReportChange(event) {
    this.currentScheduleReportSelected = event.value;
    setTimeout(() => {
      if (this.currentScheduleReportPanel != null) {
        if (this.currentScheduleReportPanel.getInitializeEvent() != null) {
          this.currentScheduleReportPanel.getInitializeEvent().emit(event);
        }
      }
    });
  }
}
